import React from "react"
import BaseModal from "./BaseModal"

const ConfirmationModal = props => {
  return <BaseModal {...props} formik={props.formik} className="modal-left" />
}

export default ConfirmationModal
